var $teilnehmerForm = $(".js-teilnehmer_form");

$(function(){

    isSubmitTeilnehmer = false;

    $teilnehmerForm.find(".js-from_submit").on("click", function(event){
        event.preventDefault();

       if(isSubmitTeilnehmer && typeof isSubmitTeilnehmer != "undefined") return false;
        $currentButton = $(this);
        $currentButton.addClass("button_disabled")
        isSubmitTeilnehmer = true;

        var idPos = $(this).data("id");
        var validSubmit = true;
        var errorCount = 0;

        $.each($teilnehmerForm.find(".js-form_input"), function(key, value){
            validInput = checkInput($(this))
            if(!validInput){
                validSubmit = false;
                errorCount++;
            }
        });

        $teilnehmerForm.find(".js-form_checkbox").each(function(){
            validInput = checkCheckbox($(this))
            if(!validInput){
                validSubmit = false;
                errorCount++;
            }
        });

        if(validSubmit){
            showLoader();

            $teilnehmerForm.find(".js-form_errorblock").hide();

            requestData = "";
            if(typeof $teilnehmerForm[0] != "undefined"){
                $teilnehmerForm.each(function(index){
                    requestData += "&" + $(this).serialize();
                });
            }

            $.ajax({
                url:$currentButton.data("ajax") + "&id=" + idPos,
                data:requestData,
                type:"POST",
                dataType: "json",
            }).done(function(response){
                $currentButton.removeClass("button_disabled")
                isSubmitTeilnehmer = false;
                if(typeof response.valid != "undefined" && response.valid == 1){
                    if(response.error_next != ""){
                        $teilnehmerForm[0].reset();
                        formMsgBlockAddText($teilnehmerForm.find(".js-form_successblock"), response.error_next)
                        formMsgBlockShow($teilnehmerForm.find(".js-form_successblock"));
                    }else{
                        $teilnehmerForm[0].reset();
                        formMsgBlockShow($teilnehmerForm.find(".js-form_successblock"));
                    }
                }else{
                    var errorCount = 0;

                    $.each(response, function(key, value){
                        var $field = $("[name=" + value + "]");
                        if($field.length > 0){
                            var $label = $field.siblings(".js-form_label");

                            // Wenn kein spezieller Label-Text angegeben -> Placeholder verwenden
                            var label_text = $field.attr("label_text");
                            if(typeof label_text == 'undefined' || label_text.length == 0) label_text = $field.attr("placeholder");

                            $label.addClass("form_label_text-error");
                            $label.text(label_text + " - " + $field.attr("title"));
                            errorCount++;
                        }
                    });
                    if(response.error_next != ""){
                        formMsgBlockSetText($teilnehmerForm.find(".js-form_errorblock"), response.error_next)
                    }
                    formMsgBlockShow($teilnehmerForm.find(".js-form_errorblock"));
                }
                hideLoader();
            });
        }else{
            $currentButton.removeClass("button_disabled")
            isSubmitTeilnehmer = false;
            formMsgBlockShow($teilnehmerForm.find(".js-form_errorblock"));
            hideLoader();
        }
    });
});


